import { CdkPortalOutlet } from '@angular/cdk/portal';
import { InjectionToken, Signal, Type, WritableSignal } from '@angular/core';
import { SidenavComponent } from '@simOn/ui/sim-sidenav';
import { SimPageTemplateComponent } from '../main-layout/sim-page-template.component';

export const PageTemplateLayout = new InjectionToken<SimPageTemplateComponent>('SimPageTemplateComponent');
export const SidenavLayout = new InjectionToken<ISidenavLayout>('SidenavLayoutComponent');
export interface ISidenavLayout {
  readonly _sidenavRight: Signal<SidenavComponent>;
  readonly _sidenavLeft: Signal<SidenavComponent>;
  readonly _outletLeft: Signal<CdkPortalOutlet>;
  readonly _outletRight: Signal<CdkPortalOutlet>;
  readonly hasBackdrop: WritableSignal<boolean>;
  get sidenavRight(): SidenavComponent;
  get sidenavLeft(): SidenavComponent;

  get outletLeft(): CdkPortalOutlet;
  set leftPanelWidth(width: string);

  get outletRight(): CdkPortalOutlet;
  set rightPanelWidth(width: string);
}

/**
 * Components rendered inside every `SidenavLayoutComponent`, after the routed content (e.g. the AI
 * assistant chat drawer). Rendering them inside the layout keeps them below the sidenav panels, which
 * live in the same stacking context. Provided by the app, so the layout stays free of feature deps.
 */
export const SIDENAV_LAYOUT_ADDONS = new InjectionToken<readonly Type<unknown>[]>('SIDENAV_LAYOUT_ADDONS', {
  providedIn: 'root',
  factory: () => []
});
